
import React, { useEffect, useState } from 'react';
// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";
import "react-image-gallery/styles/css/image-gallery.css";
import '../batman.css';
// import { TextareaAutosize } from '@material-ui/core';
import { getloginviewprofile, getmyprofile, getviewprofile, savewishlists, sendphotorequest, updatecount, userpackagedetail } from "../../action/user";
// import logo from '../../../assests/images/1.jpg';

import { useNavigate, useParams } from "react-router-dom";
import config from "../../../lib/config";

import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import whyeliteLeft from "../../../assests/images/whyelite-left.svg";
import whyeliteRight from "../../../assests/images/whyelite-right.png";
import Tabp from '../../../ui/tabpanel';
import ImageSlider from '../../sidebar/ImageSlider';

function Freesearch() {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        height: 'auto',
        bgcolor: 'background.paper',
        // border: '2px solid #ff6ed',
        boxShadow: 24,
        p: 4,
        borderRadius: '25px'
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const notify = () => toast("Saved Successfully!");
    // const [registers, setRegisters]=useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const { id } = useParams();
    const [post, setViewed] = useState({});
    const initial = {
        a1: "",
        a2: "",
        a3: "",
        a4: "",
        a5: "",
        a6: "",
        a7: "",
        a8: "",
        a9: "",
        a10: "",
        a11: "",
        a12: "",

        r1: "",
        r2: "",
        r3: "",
        r4: "",
        r5: "",
        r6: "",
        r7: "",
        r8: "",
        r9: "",
        r10: "",
        r11: "",
        r12: "",
    }

    const [box, setBox] = useState(initial);

    const {

        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10,
        a11,
        a12,

        r1,
        r2,
        r3,
        r4,
        r5,
        r6,
        r7,
        r8,
        r9,
        r10,
        r11,
        r12

    } = box

    const [profileimg, setprofileimg] = useState([]);
    const [profileimg1, setprofileimg1] = useState([]);
    const [membership, setmembership] = useState(false);
    const [savenone, setsavenone] = useState("block");
    const [createwishlistbtn, setcreatewishlistbtn] = useState("inline-block");
    const [moredetailbtn, setmoredetailbtn] = useState("show");
    const [userpackages, setuserpackages] = useState({});
    // const[jathagam,setjathagam]=useState()







    const navigate = useNavigate();

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }

    console.log("postttttttttt", post)

    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        // Pop up 의 open/close 상태에 따라
        setShowPopup(!showPopup);
    };

    const closeModal = (e) => {

        // console.log(e.target);
        if (e.target.className === "popup") {
            togglePopup();
        }
    };



    const show = () => {
        if (localStorage.user_token) {
            // console.log(Boolean(userpackages),userpackages,"userpackagesuserpackagesuserpackagesuserpackages")
            if ("package" in userpackages) {

                // 
                // console.log(typeof(localStorage.packagedetail),"hgfjhgjhfgdsjhfgdshjgjhg")
                togglePopup();
            } else {
                setmembership(false);
                window.location = "/payment";
            }
        } else {
            setmembership(false);
            window.location = "/registration";
        }
    }

    const showprofile = async () => {
        await updatecount(post._id);
        setmembership(true);
        setsavenone("none");
        togglePopup();
    }

    const savefavprofile = async () => {
        await savewishlists(post._id);
        setcreatewishlistbtn("none");
        notify()
    }

    const photorequest = async () => {
        await sendphotorequest(post._id);
    }


    useEffect(() => {

        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [hasMembership, setHasMembership] = useState(false);

    const getLoggedInData = async () => {
        const token = localStorage.getItem("user_token");
        if (!token) {
            setIsLoggedIn(false);
            setHasMembership(false);
            return;
        }
        try {
            setIsLoggedIn(true);
            // Fetch the logged-in user's profile
            const user = await getmyprofile();

            if (user?.userValue) {
                // Check membership status
                if (user.userValue.membership && user.userValue.membership.trim() !== "") {
                    setHasMembership(true);
                } else {
                    setHasMembership(false);
                }
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            setIsLoggedIn(false);
            setHasMembership(false);
        }
    };

    useEffect(() => {
        getLoggedInData();
    })

    const BlurWrapper = ({ children, condition, blurLevel = 4 }) => {
        return (
            <div style={{
                filter: condition ? 'none' : `blur(${blurLevel}px)`,
                pointerEvents: condition ? 'auto' : 'none',
                userSelect: condition ? 'auto' : 'none'
            }}>
                {children}
            </div>
        );
    };

    const getUserData = async () => {
        // if (localStorage.user_token) {

        // } else {

        // }


        if (localStorage.user_token) {
            // alert('gfdfgfgd')
            var test = await getloginviewprofile(id);
            console.log(test, "sss")
            // 
            console.log(test.userValue.userValue, "sdjhgfvjhsdfgjh");
            setViewed(test.userValue.userValue);

            var boxitems = test.userValue.userValue;
            Allboxitemss(boxitems.a1, boxitems.a2, boxitems.a3, boxitems.a4, boxitems.a5, boxitems.a6,
                boxitems.a7, boxitems.a8, boxitems.a9, boxitems.a10, boxitems.a11, boxitems.a12,
                boxitems.r1, boxitems.r2, boxitems.r3, boxitems.r4, boxitems.r5, boxitems.r6,
                boxitems.r7, boxitems.r8, boxitems.r9, boxitems.r10, boxitems.r11, boxitems.r12)
            // Allboxitemss("a2", test.userValue.userValue.a2)

            // setViewed(test.userValue.userValue);

            // const primages = test.userValue.userValue.photopath.map(e => config.API+"/images/user/"+e);
            // setprofileimg(primages);
            setprofileimg1(test.userValue.userValue.photopath[0])
            console.log(test.userValue.userValue.photopath[0], "profileimg1profileimg1profileimg1")
            if (test.userValue.userValue.photopath.length && test.userValue.userValue.photopath[0]) {
                setprofileimg(test.userValue.userValue.photopath.map(url => ({
                    original: config.API + `/images/user/${url}`,
                    // thumbnail: config.API + `/images/user/${url}`,
                    originalHeight: "200",
                    originalWidth: "200",
                    thumbnailHeight: "50",
                })))
            }
            if (test.userValue.whishlisted) {
                setcreatewishlistbtn("none");
            } else {
                setcreatewishlistbtn("inline-block");
            }

            if (test.userValue.viewlisted) {
                setmembership(true);
                setsavenone("none");
            } else {
                setsavenone("block");
            }
            var userdetail = await userpackagedetail();
            if (userdetail.success) {
                setuserpackages(userdetail.userValue)
                // setmoredetailbtn("Show more details");
                // Check if user has membership and remaining count
                if (userdetail.userValue && userdetail.userValue.remainingcount > 0) {
                    // Call updatecount only once when user views profile with membership
                    await updatecount(id);

                    // Refresh package details after updating count
                    const updatedDetail = await userpackagedetail();
                    if (updatedDetail.success) {
                        setuserpackages(updatedDetail.userValue);
                    }
                }
            } else {
                setmoredetailbtn("To purchase membership");
            }
        } else {

            var test = await getviewprofile(id);
            console.log(test, "ss")

            setViewed(test.userValue);
            setmoredetailbtn("Click here to become a member and contact them ");

            if (test.userValue.photopath.length && test.userValue.photopath[0]) {
                setprofileimg(test.userValue.photopath.map(url => ({
                    original: config.API + `/images/user/${url}`,
                    // thumbnail: config.API + `/images/user/${url}`,
                    // originalHeight: "200",
                    // originalWidth: "200",
                    thumbnailHeight: "70",

                })))
            }
        }


        // var test =  await getregister();
        // 
        // console.log(test, "bdfgfdgdf");
        // setRegisters(test.userValue);

    };
    // if (post.n_marriage = "Marriage") {

    // }

    // console.log(post  , "sdjhgfvjhsdfgjh");
    const protimages = [
        "https://cdn.stocksnap.io/img-thumbs/960w/PS7M4VMB9P.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/SVSBXHN1OU.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/KLSTPV1LBV.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/N06ELOLAT9.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/YN0MX9OUSY.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/JVBWZNCQLW.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/LN6MZNMBUR.jpg"
    ];
    const fhkjx = protimages.map(url => ({
        original: `${url}`,
        // thumbnail: `${url}`,
        originalHeight: "200",
        originalWidth: "200",
        thumbnailHeight: "50",


    }))



    // console.log(post.a1, "uttttttt");

    function Allboxitemss(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12,
        r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11, r12) {


        // const tamil_lang = [
        //     'வி',
        //     'கே',
        //     'ல',
        //     'செ',
        //     'பு',
        //     'ச',
        //     'ரா',
        //     'சனி',
        //     'சூ',
        //     'சு',
        //     'மா',
        //     'வ'
        // ];
        const tamil_lang = [
            'J',
            'K',
            'L',
            'Mar',
            'Me',
            'Mo',
            'Ra',
            'Sa',
            'Su',
            'Ve',
            'Man',
            'Va'
        ];

        // var text11 = "5/8";
        // const newarray111 = text11.split("/");
        const tamillang = ["J", "K", "L", "Mar", "Me", "Mo", "Ra", "Sa", "Su", "Ve", "Man", "Va"];

        // Add safety checks for all variables
        const newarray = (a1 || "").split(",");
        const final = newarray.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray1 = (a2 || "").split(",");
        const final1 = newarray1.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray2 = (a3 || "").split(",");
        const final2 = newarray2.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray4 = (a4 || "").split(",");
        const final4 = newarray4.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray5 = (a5 || "").split(",");
        const final5 = newarray5.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray6 = (a6 || "").split(",");
        const final6 = newarray6.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray7 = (a7 || "").split(",");
        const final7 = newarray7.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray8 = (a8 || "").split(",");
        const final8 = newarray8.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray9 = (a9 || "").split(",");
        const final9 = newarray9.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray10 = (a10 || "").split(",");
        const final10 = newarray10.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray11 = (a11 || "").split(",");
        const final11 = newarray11.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray12 = (a12 || "").split(",");
        const final12 = newarray12.map((e) => { return e ? tamillang[e - 1] : "" });

        // Rasi values
        const newarrayr1 = (r1 || "").split(",");
        const finalr1 = newarrayr1.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr2 = (r2 || "").split(",");
        const finalr2 = newarrayr2.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr3 = (r3 || "").split(",");
        const finalr3 = newarrayr3.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr4 = (r4 || "").split(",");
        const finalr4 = newarrayr4.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr5 = (r5 || "").split(",");
        const finalr5 = newarrayr5.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr6 = (r6 || "").split(",");
        const finalr6 = newarrayr6.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr7 = (r7 || "").split(",");
        const finalr7 = newarrayr7.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr8 = (r8 || "").split(",");
        const finalr8 = newarrayr8.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr9 = (r9 || "").split(",");
        const finalr9 = newarrayr9.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr10 = (r10 || "").split(",");
        const finalr10 = newarrayr10.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr11 = (r11 || "").split(",");
        const finalr11 = newarrayr11.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr12 = (r12 || "").split(",");
        const finalr12 = newarrayr12.map((e) => { return e ? tamillang[e - 1] : "" });

        var data = {
            "a1": final,
            "a2": final1,
            "a3": final2,
            "a4": final4,
            "a5": final5,
            "a6": final6,
            "a7": final7,
            "a8": final8,
            "a9": final9,
            "a10": final10,
            "a11": final11,
            "a12": final12,
            "r1": finalr1,
            "r2": finalr2,
            "r3": finalr3,
            "r4": finalr4,
            "r5": finalr5,
            "r6": finalr6,
            "r7": finalr7,
            "r8": finalr8,
            "r9": finalr9,
            "r10": finalr10,
            "r11": finalr11,
            "r12": finalr12
        }

        setBox(data);
        return final.join();
    }






    // console.log(post,"postpostpost")

    useEffect(() => {
        getUserData();

    }, []);


    const [mainImageIndex, setMainImageIndex] = useState(0);

    // const handleImageClick = (index) => {
    //     setMainImageIndex(index);
    // };

    const [isZoomed, setIsZoomed] = useState(false)
    const handleImageClick = () => setIsZoomed(true);
    const closeZoom = () => setIsZoomed(false);

    // Determine image source
    const imgSrc = profileimg.length
        ? config.API + "/images/user/" + post.photopath[0]
        : ("sex" in post && post.sex === "Male"
            ? require('../../../assests/images/man.png')
            : require('../../../assests/images/woman.png'));
    console.log('post ', post)
    return (

        // <div className="container" style={{ marginTop: "40px" }}>
        //     <div className="App">
        //         {showPopup ? (
        //             <div className="popup" onClick={(e) => closeModal(e)}>
        //                 {userpackages ?
        //                     <div className="popup_inner">
        //                         <h2>Current Package : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.package}</span></h2>
        //                         <h2>Total number : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.totalcount}</span></h2>
        //                         <h2>Viewed Count : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.viewedcount}</span></h2>
        //                         <h2>Remaining Count : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.remainingcount}</span></h2>
        //                         <div className="buttons">
        //                             <button className="btclose" onClick={showprofile}>
        //                                 Show
        //                             </button>
        //                             <button className="btclose" onClick={togglePopup}>
        //                                 Cancel
        //                             </button>
        //                         </div>
        //                     </div> : null
        //                 }
        //             </div>
        //         ) : null}
        //     </div>


        //     <a onClick={() => navigate(-1)}><button className='theri'>Go Back</button></a>

        //     <div className="pizza" >

        //         <p className='water'>{post.mname}<span className='spank'>( {post.userid} )</span></p>



        //         <div className="row" style={width <= 774 ? { height: 'auto' } : { height: '360px' }}>

        //             <div className="col-md-12 sm-12">

        //                 <div className='container'>
        //                     <div className="row " >

        //                         <div className="col-md-6 col-lg-4">
        //                             <div className='dontdon'>
        //                                 {profileimg.length ? (
        //                                     <img
        //                                         className="logo viewphotoz"
        //                                         style={{
        //                                             marginTop: "15px",
        //                                             border: 'none'
        //                                         }}
        //                                         src={config.API + "/images/user/" + post.photopath[mainImageIndex]}
        //                                         alt="Main"
        //                                     />
        //                                 ) : (
        //                                     <img
        //                                         className='donzz'
        //                                         src={"sex" in post && post.sex === "Male" ? require('../../../assests/images/man.png') : require('../../../assests/images/woman.png')}
        //                                         alt="Fallback"
        //                                     />
        //                                 )}
        //                             </div>

        //                             {post.photopath?.length > 1 && (
        //                                 <div className="additional-images-container" style={{ display: 'flex', overflowX: 'auto', marginTop: '10px', paddingBottom: '5px' }}>
        //                                     {post.photopath.map((imgPath, index) => (
        //                                         <img
        //                                             key={index}
        //                                             className="additional-image"
        //                                             src={config.API + "/images/user/" + imgPath}
        //                                             style={{
        //                                                 width: '80px',
        //                                                 height: '80px',
        //                                                 marginRight: '10px',
        //                                                 objectFit: 'cover',
        //                                                 cursor: 'pointer',
        //                                                 border: index === mainImageIndex ? '3px solid #029c09' : 'none' // Highlight selected image
        //                                             }}
        //                                             alt={`Thumbnail ${index + 1}`}
        //                                             onClick={() => handleImageClick(index)}
        //                                         />
        //                                     ))}
        //                                 </div>
        //                             )}
        //                         </div>



        //                         <div className="col-md-6 col-lg-4 content">
        //                             <table className='AnDroid' >
        //                                 <tbody>
        //                                     <tr >
        //                                         <td className='billa'>Name</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.mname}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Gender</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.sex == 'Male' ? "Male" : "Female"}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Age </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.age = new Date().getFullYear() - post.year + "" + " Yrs"}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Education</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.educ}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Caste</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.castename}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Sub Caste</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.subcaste}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>District </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.city}</td>
        //                                     </tr>

        //                                     <tr   >
        //                                         <td className='billa'>Marital Status</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.maritalname == "Marriage" ? "First Marriage" : "Remarriage"}</td>
        //                                     </tr>
        //                                     {post.maritalname == "Marriage" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Children</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.children}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Children</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.children}</td>
        //                                         </tr>}
        //                                 </tbody>
        //                             </table>
        //                         </div>

        //                         <div className="col-md-6 col-lg-4 content">
        //                             <table className="sans" >
        //                                 <tbody>
        //                                     <tr>
        //                                         <td className='billa'>Date of Birth</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.dob = post.date + "-" + post.month + "-" + post.year}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Height</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.height}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Color</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.colorname}</td>
        //                                     </tr>

        //                                     <tr>
        //                                         <td className='billa'>Occupation</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.occup}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Monthly Income</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>	{post.income}</td>
        //                                     </tr>
        //                                     {post.maritalname == "Marriage" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Remarriage reason</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.n_marriage}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Remarriage reason</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.n_marriage}</td>
        //                                         </tr>}
        //                                     {post.maritalname == "Marriage" || post.children == "No" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Children Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.child_detail}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Children Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.child_detail}</td>
        //                                         </tr>}

        //                                     <tr>
        //                                         <td className='billa'>No Caste restriction</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>	{post.castenone}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Disabled</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.handireason == "" ? "No" : 'Yes'}</td>
        //                                     </tr>
        //                                     {post.handireason ?
        //                                         <tr>
        //                                             <td className='billa'>Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>	{post.handireason}</td>
        //                                         </tr>
        //                                         : null}

        //                                 </tbody>
        //                             </table>
        //                         </div>

        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>


        //     <div className="centerFruit" >
        //         <div className='container'>

        //             <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>

        //                 <div className="col-md-12 sm-12 ">

        //                     <p className='name1'>Family Details</p>

        //                     <div className="row " >

        //                         <div className="col-md-6 ">

        //                             <table className='Boomer' >


        //                                 <tbody><tr>
        //                                     <td className='billa1'>Father's Name</td>
        //                                     <td className='kuruvi1'>:</td>
        //                                     <td className='alan1'>{post.father_name}</td>
        //                                 </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's Name</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mother_name}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Father's Occupation</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.dad_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's Occupation</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mom_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Siblings (Including this person)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.brother}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married Brothers</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.m_brother}</td>
        //                                     </tr>

        //                                 </tbody></table>
        //                         </div>
        //                         <div className="col-md-6 content">
        //                             <table className='Boomer' >
        //                                 <tbody>
        //                                     <tr>
        //                                         <td className='billa1'>Sisters (Including this person)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married Sisters</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.m_sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Registered By</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.regis}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Origin</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.puriveaam}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Assets</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.peroparty}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Dowry Details</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.dever} </td>
        //                                     </tr>


        //                                 </tbody>
        //                             </table>


        //                         </div>


        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>







        //     {membership ?
        //         <div>



        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12">

        //                         <p className='name1'>Horoscope Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-6 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Star</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.starname}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Zodiac</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.zodiacname}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Lagna</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.gothra}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Direction</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.directionname}</td>
        //                                         </tr>


        //                                     </tbody></table>
        //                             </div>
        //                             <div className="col-md-6 content">
        //                                 <table className='Boomer' >
        //                                     <tbody>
        //                                         <tr>
        //                                             <td className='billa'>Year</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_year}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Month</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_month}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Day</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.s_day}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Patham</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.patham}</td>
        //                                         </tr>

        //                                     </tbody>
        //                                 </table>


        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>


        //             <div className style={{ marginTop: '30px' }}>
        //                 <img src={require('../../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        //                 <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
        //                     <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
        //                         <tbody>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r1)}
        //                                         id="r1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r2)}
        //                                         id="r2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r3)}
        //                                         id="r3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r4)}
        //                                         id="r4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a1)}
        //                                         id="a1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a2)}
        //                                         id="a2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a3)}
        //                                         id="a3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a4)}
        //                                         id="a4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r5)}
        //                                         id="r5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td colspan="2" rowspan="2" width="124" align="center">
        //                                     <img src={require('../../../assests/images/raaasi_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td><textarea
        //                                     value={(r6)}
        //                                     id="r6"
        //                                     readonly
        //                                     style={{ textAlign: "center" }}
        //                                     minRows={3}
        //                                     Cols={8}
        //                                     formControlProps={{
        //                                         fullWidth: true,
        //                                     }} />
        //                                 </td>
        //                                 <div style={{ marginLeft: "15px" }}></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a5)}
        //                                         id="a5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td rowspan="2" colspan="2" width="133" align="center">
        //                                     <img src={require('../../../assests/images/amsam_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a6)}
        //                                         id="a6"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r7)}
        //                                         id="r7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r8)}
        //                                         id="r8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a7)}
        //                                         id="a7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td width="57" height="63" align="center">
        //                                     <textarea
        //                                         value={(a8)}
        //                                         id="a8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r9)}
        //                                         id="r9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r10)}
        //                                         id="r10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r11)}
        //                                         id="r11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r12)}
        //                                         id="r12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a9)}
        //                                         id="a9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a10)}
        //                                         id="a10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a11)}
        //                                         id="a11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a12)}
        //                                         id="a12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                         </tbody>
        //                     </table>
        //                 </div>
        //             </div>


        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12 ">

        //                         <p className='name1'>Contact Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-12 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Phone Number</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.phone_number}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Address</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.address}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Email Address</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.email_id}</td>
        //                                         </tr>

        //                                     </tbody></table>
        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>

















        //         </div>

        //         :

        //         <div>
        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12">

        //                         <p className='name1'>Horoscope Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-6 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Star</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.starname}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Zodiac</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.zodiacname}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Lagna</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.gothra}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Direction</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.directionname}</td>
        //                                         </tr>


        //                                     </tbody></table>
        //                             </div>
        //                             <div className="col-md-6 content">
        //                                 <table className='Boomer' >
        //                                     <tbody>
        //                                         <tr>
        //                                             <td className='billa'>Year</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_year}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Month</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_month}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Day</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.s_day}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Patham</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.patham}</td>
        //                                         </tr>

        //                                     </tbody>
        //                                 </table>


        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>


        //             <div className style={{ marginTop: '30px' }}>
        //                 <img src={require('../../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        //                 <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
        //                     <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
        //                         <tbody>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r1)}
        //                                         id="r1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r2)}
        //                                         id="r2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r3)}
        //                                         id="r3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r4)}
        //                                         id="r4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a1)}
        //                                         id="a1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a2)}
        //                                         id="a2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a3)}
        //                                         id="a3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a4)}
        //                                         id="a4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r5)}
        //                                         id="r5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td colspan="2" rowspan="2" width="124" align="center">
        //                                     <img src={require('../../../assests/images/raaasi_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td><textarea
        //                                     value={(r6)}
        //                                     id="r6"
        //                                     readonly
        //                                     style={{ textAlign: "center" }}
        //                                     minRows={3}
        //                                     Cols={8}
        //                                     formControlProps={{
        //                                         fullWidth: true,
        //                                     }} />
        //                                 </td>
        //                                 <div style={{ marginLeft: "15px" }}></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a5)}
        //                                         id="a5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td rowspan="2" colspan="2" width="133" align="center">
        //                                     <img src={require('../../../assests/images/amsam_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a6)}
        //                                         id="a6"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r7)}
        //                                         id="r7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r8)}
        //                                         id="r8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a7)}
        //                                         id="a7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td width="57" height="63" align="center">
        //                                     <textarea
        //                                         value={(a8)}
        //                                         id="a8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r9)}
        //                                         id="r9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r10)}
        //                                         id="r10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r11)}
        //                                         id="r11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r12)}
        //                                         id="r12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a9)}
        //                                         id="a9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a10)}
        //                                         id="a10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a11)}
        //                                         id="a11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a12)}
        //                                         id="a12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                         </tbody>
        //                     </table>
        //                 </div>
        //             </div>






        //         </div>
        //     }

        //     <button onClick={show} className='burg' style={{ display: savenone }}>{moredetailbtn}<FavoriteIcon style={{ height: '19px', width: '19px', marginLeft: '5px', marginBottom: '2px', marginTop: "0px" }} /></button>

        // </div>

        <div className="container container-top">
            <div class="topright-hide" style={{ textAlign: 'left' }}>
                <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
            </div>
            <div className="textCenter" >
                {post.membership ? <button className='theri'>{post.membership} Package</button> : null}
            </div>
            <div className="App">
                {/* <button className='kuselan' onClick={togglePopup}>Edit Profile</button> */}
                {showPopup ? (
                    <div className="popup" onClick={(e) => closeModal(e)}>
                        <div className="popup_inner">
                            <h2 style={{ color: "black", fontWeight: "bold" }}>You can change your details, contact your admin.</h2>
                            <h2 style={{ color: "black", fontWeight: "bold", marginTop: "25px" }}>Call: 96529 66888 </h2>
                            <button className="close" onClick={togglePopup}>
                                Close
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            {/* Basic Info - always visible */}
            <div className="centerFruit container" style={{ flexWrap: 'inherit' }}>
                {isLoggedIn &&
                    <span>
                        {!hasMembership && (
                            <a href="/payment">
                                <h2 style={{ color: 'red', textDecoration: 'underline' }}>Please get membership to view full details</h2>
                            </a>
                        )}
                    </span>
                    // :
                    // <span>
                    //     <a onClick={handleOpen} style={{ pointerEvents: "auto", cursor: "pointer" }}>
                    //         <h2 style={{ color: 'red', textDecoration: 'underline' }}>Please login to view details</h2>
                    //     </a>
                    // </span>
                }
                <div className="row whole-div">
                    {/* Column 1 */}
                    <div className="col-12 col-md-8 mb-3">
                        {/* <div className="flex-item">
                            <p className='valimai text-uppercase'>
                                {post.mname}
                                <p className='spank'>( {post.userid} )</p>
                            </p>
                        </div> */}
                        <div className='dark-beige'>
                            <span className='heading'>
                                <strong>PERSONAL INFORMATION</strong>
                            </span>
                        </div>
                        <div className="centerFruit container text-uppercase">
                            <div className="row">
                                <div className="col-12 col-md-8-custom mb-3 border-end">
                                    <table className="AnDroid w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.mname}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Age</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{new Date().getFullYear() - post.year} Yrs</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Race</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.castename}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Residence</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_residence}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Marital Status</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.maritalname === "Marriage" ? "First marriage" : "Remarriage"}</td>
                                            </tr>

                                            <tr>
                                                <td className="billa">Date of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.date + "/" + post.month + "/" + post.year}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Time of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.time_of_birth}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_birth}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Height</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.height}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Color</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.colorname}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">District</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.city}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Subdivision</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.subcaste}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-12 col-md-4" style={{ alignContent: 'center' }}>
                        {/* <BlurWrapper condition={isLoggedIn}> */}
                        <ImageSlider post={post} config={config} />
                        {/* </BlurWrapper> */}
                    </div>

                    {/* Column 3 */}
                    {/* <div className="col-12 col-md-4 mb-3">
                        <BlurWrapper condition={hasMembership}>
                            <div className="flex-item">
                                <h1 style={{ textAlign: 'left' }}>
                                    <strong>CONTACT INFORMATION</strong>
                                </h1>
                                <table className='Boomer'>
                                    <tbody>
                                        <tr>
                                            <td className='alan'>
                                                <i className="fa-solid fa-phone" style={{ color: 'black', padding: '10px' }}></i>
                                                {post.phone_number}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='alan'>
                                                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                    <i className="fa-solid fa-location-dot" style={{ color: 'black', padding: '10px', paddingTop: '5px' }}></i>
                                                    <span>{post.address}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='alan'>
                                                <i className="fa-solid fa-square-envelope" style={{ color: 'black', padding: '10px' }}></i>
                                                {post.email_id}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BlurWrapper>
                    </div> */}
                </div>

            </div>

            {/* <div className='dark-beige'>
                <span className='heading'>
                    <strong>PERSONAL INFORMATION</strong>
                </span>
            </div> */}
            {/* PERSONAL INFORMATION - visible to logged in users */}
            {/* <BlurWrapper condition={isLoggedIn}> */}
            {/* <div className="centerFruit container text-uppercase">
                <div className="row"> */}
            {/* Column 1 */}
            {/* <div className="col-12 col-md-4 mb-3 border-end">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Name</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.mname}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Age</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{new Date().getFullYear() - post.year} Yrs</td>
                                </tr>
                                <tr>
                                    <td className="billa">Race</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.castename}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Place of Residence</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.place_of_residence}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

            {/* Column 2 */}
            {/* <div className="col-12 col-md-4 mb-3 border-end">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Marital Status</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.maritalname === "Marriage" ? "First marriage" : "Remarriage"}</td>
                                </tr>

                                <tr>
                                    <td className="billa">Date of Birth</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.date + "/" + post.month + "/" + post.year}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Place of Birth</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.place_of_birth}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Height</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.height}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

            {/* Column 3 */}
            {/* <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Color</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.colorname}</td>
                                </tr>
                                <tr>
                                    <td className="billa">District</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.city}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Subdivision</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.subcaste}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div> */}
            {/* </div>
            </div> */}
            {/* </BlurWrapper> */}

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>EDUCATION/WORK EXPERIENCE</strong>
                </span>
            </div>
            {/* EDUCATION/WORK EXPERIENCE - visible to logged in users */}
            {/* <BlurWrapper condition={isLoggedIn}> */}
            <div className="centerFruit container text-uppercase">
                <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Job/Career</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.occup}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Work Location</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.w_place}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Salary Income</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.income}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Company Name</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.company_name}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Educational Qualification</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.educ}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Higher Educational Qualification</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.higher_education_qualification}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/* </BlurWrapper> */}

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>FAMILY INFORMATION</strong>
                </span>
            </div>
            {/* FAMILY INFORMATION - visible to members only */}
            {/* <BlurWrapper condition={hasMembership}> */}
            <div className="centerFruit container text-uppercase">
                <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                    <div className="col-md-12 sm-12">
                        <div className="row">

                            {/* Column 1 */}
                            <div className="col-12 col-md-4 mb-3 border-end">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Father's Name</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.father_name}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Mother's Name</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.mother_name}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Father's Work</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.dad_work}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Mother's Work</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.mom_work}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Community</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.castename}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 2 */}
                            <div className="col-12 col-md-4 mb-3 border-end">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Brothers (incl. this one)</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.brother}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Married Brothers</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.m_brother}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Sisters (incl. this one)</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.sister}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Married Sisters</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.m_sister}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 3 */}
                            <div className="col-12 col-md-4 mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Register</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.regis}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Native</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.puriveaam}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Properties</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.livesity}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Sear Varusai</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.ever}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* </BlurWrapper> */}

            {/* ADDRESS INFORMATION - visible to members only */}
            {isLoggedIn && (
                <>
                    <div className='dark-beige'>
                        <span className='heading'>
                            <strong>CONTACT INFORMATION</strong>
                        </span>
                    </div>
                    <BlurWrapper condition={hasMembership}>
                        <div className="centerFruit container text-uppercase" >
                            <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                                <div className="col-md-12 sm-12 ">
                                    <div className="row" >
                                        <div className="col-md-12 ">
                                            <table className='Boomer' >
                                                <tbody>
                                                    <tr>
                                                        <td className='billa'>Mobile number</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.phone_number}
                                                            { /* { (localStorage.user_token) ? (<><a href='/myprofile' style={{ color:"white", fontSize:"18px", borderRadius:"6px", backgroundColor:"#b91d97", padding:"7px 9px 12px 9px"}}>My profile</a><a onClick={onlogout} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", padding:"7px 9px 12px 9px"}} marginLeft:"9px", fontWeight:"800"}}><img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"24px"}} src={ require('../../../assests/images/logout.png') } /> Logout</a></>) : (<><a href='/registration' style={{ color:"white", fontSize:"18px", borderRadius:"6px"). backgroundColor:"#b91d97", padding:"7px 9px 12px 9px", marginLeft:"8px"}}>Registration</a> <a onClick={handleOpen} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", fontSize:"22px", marginLeft:"9px", fontWeight:"700"}}> <img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"18px"}} src={ require('../../../assests/images/person.png') } /> Login</a></>)} */}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='billa'>Address</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.address}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='billa'>Email address</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.email_id}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BlurWrapper>
                    {/* <div className='dark-beige'>
                        <span className='heading'>
                            <strong>ADDRESS INFORMATION</strong>
                        </span>
                    </div>
                    <BlurWrapper condition={hasMembership}>
                        <div className="centerFruit container text-uppercase" >
                            <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                                <div className="col-md-12 sm-12 ">
                                    <div className="row" >
                                        <div className="col-md-12 ">
                                            <table className='Boomer' >
                                                <tbody>
                                                    <tr>
                                                        <td className='billa'>Mobile number</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.phone_number}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='billa'>Address</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.address}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='billa'>Email address</td>
                                                        <td className='kuruvi'>:</td>
                                                        <td className='alan'>{post.email_id}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BlurWrapper> */}
                </>
            )}

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>HOROSCOPE INFORMATION</strong>
                </span>
            </div>
            {/* HOROSCOPE INFORMATION - visible to members only */}
            {/* <BlurWrapper condition={hasMembership}> */}
            <div className="centerFruit container text-uppercase">
                <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                    <div className="col-md-12 sm-12">
                        <div className="row">
                            {/* Column 1 */}
                            <div className="col-12 col-md-6 border-end mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Star</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.starname}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Zodiac sign</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.zodiacname}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Ascendant</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.gothra}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Directional balance</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.directionname}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 2 */}
                            <div className="col-12 col-md-6 mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Year</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_year}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Month</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_month}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Day</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_day}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Patham</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.patham}</td>
                                        </tr>
                                        {/* <tr>
                                            <td className="billa">Time of Birth</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.time_of_birth}</td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="topright-hide" style={{ textAlign: 'right' }}>
                            <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                style={{ width: '12%', marginTop: '-157px', marginRight: '-16px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* </BlurWrapper> */}

            {/* <div className='dark-beige'>
                <span className='heading'>
                    <strong>PHOTOS</strong>
                </span>
            </div> */}
            {/* PHOTOS - visible to members only */}
            {/* <BlurWrapper condition={hasMembership}>
                <div className="centerFruit container">
                    <div className="flex-item" style={{ textAlign: 'center' }}>
                        {profileimg.length ? (
                            post.photopath.map((img, index) => (
                                <img
                                    key={index}
                                    src={config.API + "/images/user/" + img}
                                    alt={`Profile ${index + 1}`}
                                    style={{
                                        float: "left",
                                        margin: "10px",
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "fit",
                                    }}
                                />
                            ))
                        ) : (
                            <img
                                src={
                                    "sex" in post && post.sex === "Male"
                                        ? require('../../../assests/images/man.png')
                                        : require('../../../assests/images/woman.png')
                                }
                                style={{ width: '70%' }}
                                alt="Default"
                            />
                        )}
                    </div>
                </div>
            </BlurWrapper> */}

            {/* RAAASI TABLE - visible to members only */}
            <BlurWrapper condition={hasMembership}>
                <div className style={{ marginTop: '0px' }}>
                    <img src={require('../../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                    <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
                        <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <textarea
                                            value={(r1)}
                                            id="r1"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r2)}
                                            id="r2"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r3)}
                                            id="r3"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r4)}
                                            id="r4"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <div style={{ margin: '30px' }}></div>
                                    <td>
                                        <textarea
                                            value={(a1)}
                                            id="a1"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a2)}
                                            id="a2"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a3)}
                                            id="a3"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a4)}
                                            id="a4"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <textarea
                                            value={(r5)}
                                            id="r5"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td colspan="2" rowspan="2" width="124" align="center">
                                        <img src={require('../../../assests/images/raaasi_en.png')} width={112} height={45} />
                                    </td>
                                    <td><textarea
                                        value={(r6)}
                                        id="r6"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                    </td>
                                    <div style={{ marginLeft: "15px" }}></div>
                                    <td>
                                        <textarea
                                            value={(a5)}
                                            id="a5"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td rowspan="2" colspan="2" width="133" align="center">
                                        <img src={require('../../../assests/images/amsam_en.png')} width={112} height={45} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a6)}
                                            id="a6"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <textarea
                                            value={(r7)}
                                            id="r7"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r8)}
                                            id="r8"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <div></div>
                                    <td>
                                        <textarea
                                            value={(a7)}
                                            id="a7"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td width="57" height="63" align="center">
                                        <textarea
                                            value={(a8)}
                                            id="a8"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <textarea
                                            value={(r9)}
                                            id="r9"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r10)}
                                            id="r10"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r11)}
                                            id="r11"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(r12)}
                                            id="r12"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <div></div>
                                    <td>
                                        <textarea
                                            value={(a9)}
                                            id="a9"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a10)}
                                            id="a10"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a11)}
                                            id="a11"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                    <td>
                                        <textarea
                                            value={(a12)}
                                            id="a12"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </BlurWrapper>
            <style jsx>
                {`
                @media (max-width: 425px) {
                    .container-top{
                        margin-top: 60px  !important;
                    }
                }`}
            </style>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Button className='timee'
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            width: "35px",
                            height: "35px",
                            minWidth: "35px",
                            color: "#BA3E3E",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            zIndex: 10,
                        }} onClick={handleClose} variant="primary">
                        <CancelIcon className='rasathi' />
                    </Button>
                    <Tabp />
                </Box>
            </Modal>
        </div>

    )
}

export default Freesearch;